/* PREVAIL v4 — interactions */
(function(){
  'use strict';
  var d=document;

  /* Sticky header */
  var h=d.getElementById('hdr')||d.querySelector('.header');
  if(h){var s=function(){h.classList.toggle('stuck',window.scrollY>30);};window.addEventListener('scroll',s,{passive:true});s();}

  /* Reveal on scroll */
  var rev=d.querySelectorAll('.reveal');
  if('IntersectionObserver' in window && rev.length){
    var io=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
    rev.forEach(function(el){io.observe(el);});
  }else{rev.forEach(function(el){el.classList.add('in');});}

  /* Accordions (studies + faq) */
  function acc(sel){
    d.querySelectorAll(sel).forEach(function(q){
      q.addEventListener('click',function(){
        var it=q.parentElement;
        var a=it.querySelector('.study__a,.faq__a');
        if(!a)return;
        var o=it.classList.contains('open');
        it.classList.toggle('open');
        a.style.maxHeight=o?null:a.scrollHeight+'px';
      });
    });
  }
  acc('.study__q');acc('.faq__q');

  /* Mobile nav */
  var b=d.getElementById('burger')||d.querySelector('.burger'),m=d.getElementById('mnav')||d.querySelector('.mnav');
  if(b&&m){b.addEventListener('click',function(){m.classList.add('open');});
    m.querySelectorAll('[data-close],a').forEach(function(e){e.addEventListener('click',function(){m.classList.remove('open');});});}

  /* Smooth anchors */
  d.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){var id=a.getAttribute('href');if(id.length>1){var t=d.querySelector(id);if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}}});
  });

  /* Purchase options: one-time vs subscribe */
  d.querySelectorAll('[data-purchase]').forEach(function(box){
    var plan=box.querySelector('[data-selling-plan]');
    var row=box.querySelector('.ptier');
    var priceWas=row?row.querySelector('[data-price-was]'):null;
    var priceNow=row?row.querySelector('[data-price-now]'):null;
    var subLabel=row?row.querySelector('[data-tier-sub]'):null;
    var subLabelOriginal=subLabel?subLabel.textContent:'';
    box.querySelectorAll('input[name="purchase_mode"]').forEach(function(r){
      r.addEventListener('change',function(){
        var sub=r.value==='subscribe';
        box.querySelectorAll('.pmode label').forEach(function(l){l.classList.toggle('sel',l.getAttribute('data-mode')===r.value);});
        if(plan)plan.value=sub?plan.getAttribute('data-selling-plan'):'';
        if(row&&row.getAttribute('data-sub-price')){
          if(sub){
            if(priceNow)priceNow.textContent=row.getAttribute('data-sub-price');
            if(priceWas){priceWas.textContent=row.getAttribute('data-sub-was');priceWas.style.display='';}
            if(subLabel)subLabel.textContent='Delivered monthly \u00b7 cancel anytime';
          }else{
            if(priceNow)priceNow.textContent=row.getAttribute('data-onetime-price');
            if(priceWas)priceWas.style.display='none';
            if(subLabel)subLabel.textContent=subLabelOriginal;
          }
        }
      });
    });
  });
})();

/* LEVEL-UP: sticky add-to-cart + count-up */
(function(){
  var d=document;
  /* Duplicate strip items for seamless marquee */
  var track=d.querySelector('.strip__in');
  if(track && !track.dataset.dup){ track.dataset.dup=1; track.innerHTML+=track.innerHTML; }

  /* Sticky ATC */
  var bar=d.querySelector('[data-satc]');
  if(bar){
    var footer=d.querySelector('.footer');
    var onScroll=function(){
      var past=window.scrollY>window.innerHeight*0.85;
      var nearEnd=false;
      if(footer){var r=footer.getBoundingClientRect();nearEnd=r.top<window.innerHeight+120;}
      bar.classList.toggle('show', past && !nearEnd);
    };
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  }

  /* Count-up */
  var nums=d.querySelectorAll('.n[data-count]');
  if('IntersectionObserver' in window && nums.length){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting)return;
        var el=e.target, target=parseInt(el.dataset.count,10)||0, suf=el.dataset.suffix||'';
        if(target===0){el.firstChild&&(el.firstChild.nodeValue='0');io.unobserve(el);return;}
        var t0=null,dur=1100;
        function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1); var v=Math.round((1-Math.pow(1-p,3))*target);
          el.childNodes[0].nodeValue=String(v); if(p<1)requestAnimationFrame(step); }
        requestAnimationFrame(step); io.unobserve(el);
      });
    },{threshold:.5});
    nums.forEach(function(n){io.observe(n);});
  }
})();
